import * as SDK from '@replai-platform/sdk';
import * as provider from './provider';

/**
 * Get market networks
 */
export async function getNetworks(request: SDK.GetMarketNetworksRequest): Promise<SDK.GetMarketNetworksResponse> {
  return provider.getJson(`${SDK.BASE_URL()}/market/networks?${SDK.convertRequestToQueryParams(request)}`);
}
